import {
	ColumnDef,
	getCoreRowModel,
	getFilteredRowModel,
	getPaginationRowModel,
	getSortedRowModel,
	useReactTable,
} from "@tanstack/react-table";
import { useMemo } from "react";
import ClientSideTable from "../components/table/ClientSideTable";
import {
	Box,
	Button,
	Flex,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Tag,
	useDisclosure,
} from "@chakra-ui/react";
import { usePrinters } from "../hooks/printers.hooks";
import PlusIcon from "../components/icons/PlusIcon";
import PageSectionTitle from "../components/PageSectionTitle";
import PrimaryButton from "../components/PrimaryButton";
import CreatePrinterForm from "../components/forms/CreatePrinterForm";
import TrashIcon from "../components/icons/TrashIcon";
import { useMutation, useQueryClient } from "react-query";
import { deletePrinter } from "../mutations/printer.mutations";
import { Printer } from "../types/printer.types";

function SettingsPagePrinterPanel() {
	const queryClient = useQueryClient();
	const { mutate: mDeletePrinter } = useMutation(deletePrinter, {
		onSuccess: () => {
			queryClient.invalidateQueries("printers");
		},
	});
	const columns = useMemo<ColumnDef<Printer>[]>(
		() => [
			{
				accessorFn: (row) => row.label,
				id: "label",
				header: "Imprimante",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
			{
				accessorFn: (row) => (
					<Flex h="44px" alignItems="center">
						<Tag>{row.type}</Tag>
					</Flex>
				),
				id: "type",
				header: "Type",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
			{
				accessorFn: (row) => (
					<TrashIcon
						onClick={() => {
							mDeletePrinter({ printer: row });
						}}
					/>
				),
				id: "actions",
				header: "",
				cell: (info) => info.getValue(),
				sortDescFirst: true,
			},
		],
		[],
	);
	const { data: rawData } = usePrinters();
	const data = useMemo(() => rawData ?? [], [rawData]);
	const table = useReactTable({
		data: data,
		columns: columns,
		getCoreRowModel: getCoreRowModel(),
		getSortedRowModel: getSortedRowModel(),
		getPaginationRowModel: getPaginationRowModel(),
		getFilteredRowModel: getFilteredRowModel(),
	});
	const { isOpen, onOpen, onClose } = useDisclosure();

	return (
		<>
			{/* Add modal */}
			<Modal isOpen={isOpen} onClose={onClose} isCentered size={"xl"}>
				<ModalOverlay bg="blackAlpha.300" backdropFilter="blur(6.9px)" />
				<ModalContent>
					<ModalHeader>Ajouter une imprimante</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<CreatePrinterForm onSubmit={onClose}></CreatePrinterForm>
					</ModalBody>
					<ModalFooter>
						<Button variant="outlined" color="brand.700" onClick={onClose}>
							Fermer
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>

			<Flex justifyContent={"space-between"}>
				<PageSectionTitle>Imprimantes</PageSectionTitle>
				<PrimaryButton w="14rem" onClick={onOpen}>
					<PlusIcon mr="4px"></PlusIcon>Ajouter une imprimante
				</PrimaryButton>
			</Flex>
			<Box w="100%">
				<ClientSideTable
					table={table}
					w={["auto", "22rem", "2rem"]}
					flexGrow={[1, 0, 0]}
					toolboxButtons={false}
				></ClientSideTable>
			</Box>
		</>
	);
}

export default SettingsPagePrinterPanel;
